import React from 'react';
import './index.scss'
import { AppHeader, AppFooter } from '@/components'
import { Route } from 'react-router-dom'
import Technology from './Technology/index'
import BIM from './BIM/index'
import Information from './Information/index'
import Metering from './Metering/index'
import Robot from './Robot/index'
import Development from './Development/index'
import Train from './Train/index'
import Platform from './Platform/index'
import { NavBars, NavContainer } from '@/components/mixins'
import { cookieUtil } from '@/assets/js/cookie'
let Swiper = window.Swiper
const $ = window.$;
class EcosphereDetails extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      title: [
        {
          name: 'BIM技术',
          id: '0',
          url: '/Technology'
        },
        {
          name: 'BIM应用咨询',
          id: '1',
          url: '/BIM'
        },
        {
          name: '建设工程大数据',
          id: '2',
          url: '/Information'
        },
        {
          name: '工程造价标准化作业',
          id: '3',
          url: '/Metering'
        },
        {
          name: '智慧造价机器人',
          id: '4',
          url: '/Robot'
        },
        {
          name: '信息系统',
          id: '5',
          url: '/Development'
        },
        {
          name: '互联网',
          id: '6',
          url: '/Platform'
        },
        {
          name: '知识分享',
          id: '7',
          url: '/Train'
        },
      ],
      NavBarsData: {
        title: '工程咨询生态圈',
        rootPath: '/Products/EcosphereDetails'
      },
      navSwiper: '',
      showNav: false,
      scrollTop: 0
    }
  }
  componentDidMount() {
    const that = this
    const showNav = cookieUtil.get('showNav')
    // 初始化
    this.setState({
      navSwiper: new Swiper('#tab-container-02', {
        speed: 500,
        autoHeight: true,
        lazy: {
          loadOnTransitionStart: true
        },
        on: {
          slideChangeTransitionStart: function () {
            const scrollTop = $(window).scrollTop();
            for (let index = 0; index < that.state.title.length; index++) {
              const item = that.state.title[index];
              if (index === this.activeIndex) {
                const pathname = '/Products/EcosphereDetails' + item.url
                that.props.history.push(pathname)
                const dom = document.getElementsByClassName('navbars-title')[this.activeIndex].getElementsByTagName('a')[0];
                that.handlePosition(dom)
                break;
              }
            }
            that.state.navSwiper.slideTo(this.activeIndex, 1000, false);
            const top1 = document.getElementsByClassName('nav-container')[0].clientHeight;
            if (scrollTop >= top1) {
              window.scrollTo(0, top1);
            }
          }
        }
      }),
      showNav: showNav
    })
    // this.handleRouterUrl()
    that.stickFn();
  }
  componentDidUpdate() {
    // 路由点击时
    this.handleRouterUrl()
  }
  stickFn() {
    const top1 = document.getElementsByClassName('top')[0];
    const top2 = document.getElementsByClassName('nav-container')[0].clientHeight;
    const fixedHeight = top1.clientHeight + top2;
    $(window).scroll(function () {
      var scroH = $(this).scrollTop();
      if (scroH >= fixedHeight) {
        $(".nav-container").css({ "position": "fixed", "top": 0, "left": 0, 'zIndex': 3, "width": '100%', "background": '#fff', 'overflow': 'auto' });
      } else {
        $(".nav-container").css({ "position": "relative" });
      }
    })
  }
  handleRouterUrl() {
    for (let index = 0; index < this.state.title.length; index++) {
      const item = this.state.title[index];
      const pathname = this.props.location.pathname
      if (pathname.includes(item.url)) {
        // this.props.history.push(pathname)
        this.state.navSwiper.slideTo(index)
        break;
      }
    }
  }
  // handleNavToggle(e, value) {
  //   this.state.navSwiper.slideTo(value)
  //   // 点击会获得最里面的值
  //   const ev = e || window.event;
  //   const target = ev.target || ev.srcElement;
  //   this.handlePosition(target)
  // }
  handlePosition(dom) {
    const that = $(dom)
    const moveX = that.position().left + that.parent().parent().scrollLeft();
    // console.log(that.parent().parent().parent(), 'that.parent().parent().parent()')
    const pageX = document.documentElement.clientWidth;
    const blockWidth = that.width();
    const left = moveX - (pageX / 2) + blockWidth / 2;
    // console.log(moveX, 'move')
    // console.log(pageX, 'pageX')
    // console.log(blockWidth, 'df')
    // console.log(left)
    $('.details-nav').scrollLeft(left)
  }
  handleShowNav() {
    if (cookieUtil.get('showNav')) {
      this.props.history.push('/')
    } else {
      this.setState({
        showNav: !this.state.showNav
      }, () => {
        this.preventScroll()
      })
    }
    cookieUtil.unset('showNav')
    console.log('df')
    // console.log(this.state.showNav, '是否点击')
  }
  preventScroll() {
    const that = this
    if (this.state.showNav) {
      var scrolltop = that.getScrollTop()
      this.setState({
        scrollTop: scrolltop
      })
      document.body.classList.add('dialog-open')
      document.body.style.top = scrolltop
    } else {
      document.body.classList.remove('dialog-open');
      that.to(this.state.scrollTop)
    }
  }
  getScrollTop() {
    return document.documentElement.scrollTop || document.body.scrollTop
  }
  to(scrollTop) {
    document.body.scrollTop = document.documentElement.scrollTop = scrollTop
  }
  componentWillUnmount() {
    cookieUtil.unset('showNav')
  }
  render() {
    return (
      <div className="EcosphereDetails">
        <Route component={AppHeader} />
        <div className="nav-container">
          {/* <ul className="details-nav">
            {
              this.state.title.map((item, index) =>
                <li className="navbars-title" key={index}>
                  <NavLink to={'/Products/EcosphereDetails' + item.url}
                    activeClassName="active" onClick={(e) => this.handleNavToggle(e, item.id)}>{item.name}</NavLink>
                </li>
              )
            }
          </ul> */}
          <NavContainer title={this.state.title} NavBarsData={this.state.NavBarsData}></NavContainer>
          <span className="nav-small-icon" onClick={(e) => this.handleShowNav(e)}>
            <svg width='100%' height="100%">
              <rect width="40%" height="40%" x="0" y="0" style={{ fill: 'rgb(255,255,255)', strokeWidth: 1, stroke: 'rgb(0,0,0)' }} />
              <rect width="40%" height="40%" x="55%" y="0" style={{ fill: 'rgb(255,255,255)', strokeWidth: 1, stroke: 'rgb(0,0,0)' }} />
              <rect width="40%" height="40%" x="0" y="55%" style={{ fill: 'rgb(255,255,255)', strokeWidth: 1, stroke: 'rgb(0,0,0)' }} />
              <rect width="40%" height="40%" x="55%" y="55%" style={{ fill: 'rgb(255,255,255)', strokeWidth: 1, stroke: 'rgb(0,0,0)' }} />
            </svg>
          </span>
        </div>
        <section className="swiper-container" id="tab-container-02" >
          <div className="swiper-wrapper" >
            <article className="swiper-slide" >
              <Technology></Technology>
            </article>
            <article className="swiper-slide" >
              <BIM></BIM>
            </article>
            <article className="swiper-slide" >
              <Information></Information>
            </article>
            <article className="swiper-slide" >
              <Metering></Metering>
            </article>
            <article className="swiper-slide" >
              <Robot></Robot>
            </article>
            <article className="swiper-slide" >
              <Development></Development>
            </article>
            <article className="swiper-slide" >
              <Platform></Platform>
            </article>
            <article className="swiper-slide" >
              <Train></Train>
            </article>
          </div>
        </section>
        <Route component={AppFooter} />
        {this.state.showNav ?
          <NavBars NavBarsData={this.state.NavBarsData} NavBarData={this.state.title}
            handleShowNav={this.handleShowNav.bind(this)}></NavBars> : ''
        }
      </div>
    )
  }
}
export default EcosphereDetails
